module.exports = __webpack_public_path__ + "static/img/xinshen.f189f42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xinshen.png
// module id = fMSm
// module chunks = 17